import { Tab, TabGroup, TabList } from '@headlessui/react';

import TabButton from '@/components/atoms/TabButton';

export interface ITabItemRouted {
  tabId: string;
  label: string;
}

export interface TabsProps {
  items: ITabItemRouted[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

export const Tabs: FC<TabsProps> = ({ items, activeTabId, onTabChange }) => (
  <TabGroup>
    <div className='mx-5 pb-3'>
      <TabList className='mt-3 flex flex-wrap border-b border-none'>
        {items.map((item) => (
          <Tab as='div' className='rounded-lg p-0.5 outline-hidden' key={item.tabId}>
            {(_tabRenderProps) => (
              <TabButton
                label={item.label}
                onClick={() => onTabChange(item.tabId)}
                isActive={activeTabId === item.tabId}
                tabId={item.tabId}
              />
            )}
          </Tab>
        ))}
      </TabList>
    </div>
  </TabGroup>
);
